/** Days in a week */
export const daysPerWeek = 7 as const;

/** Enumerates month names to the 0-indexed value */
export enum Month {
  January,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December,
}
